import { Tooltip } from 'primereact/tooltip'

export default function DescriptionTooltip({
  fieldName,
  fieldDescription,
}) {
  return (
    <>
      <i
        className="pi pi-info-circle"
        style={{ fontSize: '14px' }}
        id={`info_icon_${fieldName}`}
      />
      <Tooltip target={`#info_icon_${fieldName}`} className="custom-tooltip" position='top' style={{ width: "30%" }} >
        <span>
          {fieldDescription}
        </span>
      </Tooltip>
    </>
  )
}
